import styled from 'styled-components';
import { AspectRatio, media } from '@higo/ui';
import { FC } from 'react';
import { StyleProps } from '@summer/jst-react';

const Container = styled.div`
  margin: 0 auto;
  position: relative;
  justify-content: center;

  ${media.mobile.max} {
    width: 100%;
  }
  ${media.mobile.min}, ${media.tablet.min} { {
    width: 640px;
  }

`;

const Content = styled(AspectRatio)`
  max-width: 40rem;
  display: block;
`;

export const FullFrameDiagnosticPhotosGalleryContainer: FC<StyleProps> = ({
  children,
  ...props
}) => (
  <Container {...props} id="full-frame-gallery-container">
    <Content ratio="8x7">{children}</Content>
  </Container>
);
